import { IAction } from '../action';

// #region -------------- Action types -------------------------------------------------------------------

export const actionTypes = {
  requestReportsList: 'reportManager/REQUEST_REPORTS_LIST',
  receiveReportsList: 'reportManager/RECEIVE_REPORTS_LIST',
  downloadReport: 'reportManager/DOWNLOAD_REPORT',
  reportDownloadStatus: 'reportManager/REPORT_DOWNLOAD_STATUS',
  removeReport: 'reportManager/REMOVE_REPORT',
  reportRemoveStatus: 'reportManager/REPORT_REMOVE_STATUS',
  removeMessage: 'reportManager/REMOVE_MESSAGE',
};

// #endregion

// #region -------------- Actions -------------------------------------------------------------------

export function loadReportsList() {
  return {
    type: actionTypes.requestReportsList,
  };
}

export function downloadReport(payload: string): IAction {
  return {
    type: actionTypes.downloadReport,
    payload,
  };
}

export function removeReport(payload: string): IAction {
  return {
    type: actionTypes.removeReport,
    payload,
  };
}

export function removeMessage() {
  return {
    type: actionTypes.removeMessage,
  };
}

// #endregion
